import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AccessibilityHiddenImg } from '@skillz/accessibility';
import { postJson } from "../../../../../../shared/utils/utils";
import { processResponse } from "../../../../../../shared/store/helps/processResponse";
import { entitiesActions } from "../../../../../../shared/store/redux/entities-slice";
import { sendActionEvent } from "../../../../../../shared/utils/analytics/ga4";
import { logError } from "../../../../../../shared/errors/logError";
import waitForCreateStudyGroupImg from "../../../../../../assests/createStudyGroup/waitForCreateStudyGroup.png";
import entitysType from "../../../../../../shared/enums/entitysType";
import classes from "./FetchCreateCourse.module.css"

const FetchCreateCourse = ({ providerKey, entityField, courseData, setCourseData, goToNextStep }) => {

    const { texts } = useSelector(state => state.translate);
    const uiData = useSelector(state => state.uiData)
    const myProvider = useMemo(() => uiData?.providers?.find(provider => provider.name === providerKey), [uiData, providerKey])
    const dispatch = useDispatch()

    useEffect(() => {
        fetchCreate();
    }, [])

    const fetchCreate = async () => {
        if (myProvider) {
            const data = {
                studyGroupId: courseData?.studyGroupId,
                name: courseData?.newName || courseData.name,
                description: courseData?.description
            }
            const startedAt = Date.now();
            logError({ type: "create-study-group", error: "create_study_group_start", desc: "create_study_group_start", component: "FetchCreateCourse", props: { startedAt, studyGroupId: data.studyGroupId } });
            let createdCourseRes;
            try {
                createdCourseRes = await postJson(`${window.config.baseApiUrl}${myProvider.additionalProperties?.createCourseData?.url}`, data);
                sendActionEvent("create-group", providerKey);
                if (createdCourseRes.status === 200) {
                    const endpointKey = myProvider.additionalProperties?.createCourseData?.endpointKey
                    const myCreateCourseData = { ...myProvider.endpoints[endpointKey], endpointKey }
                    if (myCreateCourseData) {
                        const courseDataWithNmm = {
                            ...createdCourseRes.body?.course,
                            nmmId: courseData?.studyGroupId
                        };

                        const resProcessResponse = processResponse(entitysType.course, [courseDataWithNmm], myCreateCourseData, myProvider, uiData);
                        if (resProcessResponse?.entitiesList)
                            dispatch(entitiesActions.addEntities(resProcessResponse.entitiesList));
                        const groupUpdate = { groupId: createdCourseRes.body?.course?.id, support: true };
                        dispatch(entitiesActions.updateEntity({
                            entityId: courseData?.studyGroupId,
                            entityType: entitysType.studyGroup,
                            updates: {
                                ...(entityField != null && { [entityField]: groupUpdate }),
                                disable: true,
                                message: texts.courseExistDisable
                            }
                        }));
                    }
                }
            }
            catch (e) {
                console.error("error", e);
                logError({ type: "create-study-group", error: "create_study_group_error", desc: "create_study_group_error", component: "FetchCreateCourse", props: { studyGroupId: data.studyGroupId } });
            }
            finally {
                logError({ type: "create-study-group", error: "create_study_group_end", desc: "create_study_group_end", component: "FetchCreateCourse", props: { startedAt, endedAt: Date.now(), durationMs: Date.now() - startedAt, studyGroupId: data.studyGroupId } });
                setCourseData(pre => ({
                    ...pre,
                    response: createdCourseRes
                }))
                goToNextStep?.()
            }
        } else {
            logError({ type: "create-study-group", error: "create_study_group_skipped_no_provider", desc: "create_study_group_skipped_no_provider", component: "FetchCreateCourse", props: { studyGroupId: courseData?.studyGroupId } });
        }
    }

    return (
        <div className={classes.FetchCreateCourse}>
            <AccessibilityHiddenImg className={classes.Img} src={waitForCreateStudyGroupImg} />
            <p>{texts.WaitAminuteWereSettingUpTheClassroomForYou}</p>
        </div>
    )
}

export default FetchCreateCourse;
